<template>
  <IonItemSliding>
    <IonItem lines="none">
      <div class="my-2" slot="start">
        <img class="object-cover rounded-md w-[70px] h-[70px]" :alt="photo.name" :src="photo.url" />
      </div>
      <IonLabel>
        <div class="font-bold text-xs flex-nowrap overflow-hidden text-gray-700">{{ photo.createdBy }}</div>
        <div v-if="photo.createdAt" class="text-xs font-medium flex-nowrap overflow-hidden text-gray-500">
          {{ formatTimeAgo(photo.createdAt) }}
        </div>
      </IonLabel>
    </IonItem>
    <IonItemOptions slot="end" v-if="photo.createdBy && photo.createdBy === auth.user?._id">
      <IonItemOption @click="$emit('deleteClicked')" color="danger">
        <i class="icon-trash-2"></i>
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>
</template>

<script setup lang="ts">
import { useAuth } from '@/stores/auth.store';
import { IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/vue';
import { IDocument } from '@ncss/models';
import { formatTimeAgo } from '@vueuse/core';

const auth = useAuth();

defineEmits<{
  (e: 'deleteClicked'): void;
}>();

defineProps<{
  photo: IDocument;
}>();
</script>

<style scoped></style>
